import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { authSession } from './services/auth'
import './styles.css'

createApp(App).use(router).mount('#app')
void authSession.initialize()
